import { dialogDefault, DIALOG_GRADUACION } from "../consts";

const mydialog = {  
    open: false,
    id: 0, 
    editable: true,
    clientId : 0
}

export default function graduacionReducer(state = mydialog, { type, payload }) {
    const actions = {
        [DIALOG_GRADUACION] : () => ({...state, ...payload })
    }

    return actions[type]?.call() || state;
}

export const updateGraduacion = graduacion    => ({
    type: DIALOG_GRADUACION,
    payload: graduacion
});
